import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack} from 'views/components';

import {translate} from 'views/module';

/**
 * Display author's name and timestamp label
 * @param {object} props
 * @param {boolean} props.important toggle a stylized timestamp label
 * @param {object} props.nameSx style the author fullName typography
 * @return {ReactJSXElement}
 */
const Author = (props) => {
  const {
    fullName,
    timestampLabel,
    important,
    nameSx,
    messageSource,
  } = props;

  const timestampStyle = {
    fontSize: '12px',
    color: important ? 'primary.main' : 'grey.600',
    display: 'grid',
    alignItems: 'center',
  };

  const userSource = {
    'SLACK': translate('correspondances.Slack'),
  };

  return (
    <Stack>
      <Stack spacing={{md: 1, xs: 0}} direction={{md: 'row', xs: 'column'}}>
        <Typography variant='subtitle1' sx={nameSx}>
          {fullName}
        </Typography>
        <Typography variant='subtitle2' sx={timestampStyle}>
          {important && <>{'⚫︎ '}</>}
          {timestampLabel}
        </Typography>
      </Stack>
      {
        userSource[messageSource] &&
        <Typography variant='subtitle1' sx={timestampStyle}>
          {`(${translate('correspondances.Source')}: ${userSource[messageSource]})`}
        </Typography>
      }
    </Stack>
  );
};
Author.propTypes = {
  fullName: PropTypes.string.isRequired,
  timestampLabel: PropTypes.string.isRequired,
  important: PropTypes.bool,
  nameSx: PropTypes.object,
  messageSource: PropTypes.string,
};

export default React.memo(Author);
